module.exports = __webpack_public_path__ + "img/clipboard-x.e0d275e3.svg";